import styled from 'styled-components';
import { Container } from './../styles/Common';

const Footer = () => {

  return (
    <>
      <Wrapper>
        <Container>
          <Inner>
            <h2>Creating a brighter future for online business</h2>
            <div>
              <ContactUsButtonWrapper
                href="https://calendly.com/info-ripify"
                target="_blank"
              >
                <span>Contact Us</span>
              </ContactUsButtonWrapper>
            </div>
          </Inner>
        </Container>
      </Wrapper>
      <CopyrightSection>
        Copyright@ripify2022. All Rights Reserved
      </CopyrightSection>
    </>
  );
};

export default Footer;

const Wrapper = styled.div`
  padding: 120px 0;
  background-image: url('/assets/images/footer-bg.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;

  @media (max-width: 576px) {
    padding: 40px 0;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    max-width: 25ch;
    font-weight: 600;
    font-size: 45px;
    line-height: 1.3;
    text-align: center;
    letter-spacing: 3px;
    text-transform: capitalize;
    background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 40px;

    @media (max-width: 576px) {
      margin-bottom: 40px;
      font-size: 32px;
    }
  }
`;

const ContactUsButtonWrapper = styled.a<any>`
  padding: 2px 2px 2.5px 2px;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    96.91deg,
    #5ca6ed 0%,
    #5f60ef 48.46%,
    #b174f8 100%
  );
  cursor: pointer;

  span {
    background-color: #edf2f5;
    padding: 22px 25px;
    font-family: font-medium;
    font-size: 15px;
    font-weight: 500;
    color: #000;
    transition: 0.3s;
    letter-spacing: 3px;
  }

  &:hover {
    span {
      background-color: rgba(237, 242, 245, 0);
      color: #fff;
    }
  }
`;

const CopyrightSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1d334b;
  padding: 27px;
  font-weight: 500;
  font-family: font-medium;
  font-size: 16px;
  letter-spacing: 1.2px;
  color: #e1e1e1;

  @media (max-width: 576px) {
    font-size: 13px;
    padding: 10px 15px;
    text-align: center;
    line-height: 1.8;
  }
`;
